import { createContext } from "react";

import { AppModeContextType } from "@models/components/kiosk.model";

const AppModeContext = createContext<AppModeContextType | undefined>(undefined);

export default AppModeContext;
